import React from 'react';
import { Eye, ThumbsUp, Clock, MessageCircle } from 'react-feather';

const VideoInfo = ({ videoMetadata, analysisDate }) => {
  if (!videoMetadata) return null;

  const getYouTubeUrl = () => {
    if (videoMetadata.videoId) {
      return `https://www.youtube.com/watch?v=${videoMetadata.videoId}`;
    }
    return '#';
  };

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
  };

  const formatDate = (date) => {
    if (!date) return 'Unknown';
    const d = date instanceof Date ? date : new Date(date);
    return d.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="rounded-2xl p-4 sm:p-6 mb-8 flex flex-col md:flex-row gap-4 md:gap-6 shadow-lg text-white bg-gradient-to-r from-primary-500 to-secondary-500 overflow-hidden items-start">
      <a
        href={getYouTubeUrl()}
        target="_blank"
        rel="noopener noreferrer"
        className="block w-full md:w-[420px] shrink-0"
        data-testid="videoinfo-thumb"
      >
        {videoMetadata.thumbnailUrl && (
          <div className="aspect-video overflow-hidden rounded-xl shadow-lg">
            <img
              src={videoMetadata.thumbnailUrl}
              alt={videoMetadata.videoTitle}
              className="w-full h-full object-cover block"
            />
          </div>
        )}
      </a>
      
      <div className="flex-1 flex flex-col gap-3 min-w-0">
        <a
          href={getYouTubeUrl()}
          target="_blank"
          rel="noopener noreferrer"
          className="text-lg sm:text-xl md:text-2xl font-bold text-white leading-tight drop-shadow-md m-0 hover:underline transition-all break-words overflow-wrap-anywhere"
        >
          {videoMetadata.videoTitle || 'Untitled Video'}
        </a>
        
        <div className="flex items-center gap-2 text-base flex-wrap">
          <span className="font-semibold opacity-90">Channel:</span>
          <span className="font-medium break-words">{videoMetadata.channelName || 'Unknown'}</span>
        </div>

        <div className="flex gap-3 sm:gap-6 flex-wrap">
          {(videoMetadata.commentCount !== undefined && videoMetadata.commentCount !== null && videoMetadata.commentCount > 0) && (
            <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-secondary-800">
              <MessageCircle size={20} />
              <span className="font-bold text-lg">{formatNumber(videoMetadata.commentCount)}</span>
              <span className="text-sm opacity-90">comments</span>
            </div>
          )}
          
          <div className="flex items-center gap-2 bg-white bg-opacity-20 px-4 py-2 rounded-lg backdrop-blur-sm">
            <Eye size={20} />
            <span className="font-bold text-lg">{formatNumber(videoMetadata.viewCount || 0)}</span>
            <span className="text-sm opacity-90">views</span>
          </div>
          
          <div className="flex items-center gap-2 bg-white bg-opacity-20 px-4 py-2 rounded-lg backdrop-blur-sm">
            <ThumbsUp size={20} />
            <span className="font-bold text-lg">{formatNumber(videoMetadata.likeCount || 0)}</span>
            <span className="text-sm opacity-90">likes</span>
          </div>
          
          {videoMetadata.duration && (
            <div className="flex items-center gap-2 bg-white bg-opacity-20 px-4 py-2 rounded-lg backdrop-blur-sm">
              <Clock size={20} />
              <span className="font-bold text-lg">{videoMetadata.duration}</span>
              <span className="text-sm opacity-90">duration</span>
            </div>
          )}
        </div>

        {analysisDate && (
          <div className="flex items-center gap-2 text-sm opacity-90">
            <span className="font-semibold">Analyzed:</span>
            <span className="font-medium">{formatDate(analysisDate)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoInfo;

